import type { EntityReference } from '@clsplus/api-types/api-admin'

import { getTokens } from '../../helpers/auth'

function getVenuesRefData(): Promise<EntityReference[]> {
  const tokens = getTokens()

  return fetch(`${import.meta.env.VITE_API_URL}admin/reference-data/venues`, {
    headers: { Authorization: `Bearer ${tokens?.accessToken}` },
  })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw new Error(data.error)
      }

      return data
    })
}

export const venuesRefDataQuery = {
  queryKey: ['venues-ref-data'],
  queryFn: () => getVenuesRefData(),
}
